var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"font-semibold text-lg mb-4"},[_vm._v("Sample Template")]),_c('p',{staticClass:"p-4 bg-f4f5f6 rounded-lg caption-textbox font-semibold cursor-pointer"},[_c('span',{staticClass:"text-muted-g"},[_vm._v(" Dear {#var#} our otp is {#var#} ")])])])
}]

export { render, staticRenderFns }